import '../sass/text-and-media-collage-carousel.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-education-swiper-js');
    const rellaxScript = document.querySelector('#ofg-education-rellax-js');
    const $blocks = document.querySelectorAll('.block.text-and-media-collage-carousel');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $pagination = $block.querySelector('.text-and-media-collage-carousel__pagination');
        const $textCarousel = $block.querySelector('.text-and-media-collage-carousel__text-carousel');
        const $accordions = $block.querySelectorAll('.text-and-media-collage-carousel__accordion');
        const $mediaCarousels = $block.querySelectorAll('.text-and-media-collage-carousel__media-carousel');
        const $prev = $block.querySelector('.text-and-media-collage-carousel__text-carousel-navigation-prev');
        const $next = $block.querySelector('.text-and-media-collage-carousel__text-carousel-navigation-next');

        const initCarousels = () => {
            let mediaCarousels = [];

            if ($mediaCarousels) {
                $mediaCarousels.forEach($mediaCarousel => {
                    const mediaCarousel = new Swiper($mediaCarousel, {
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true
                        },
                        allowTouchMove: false,
                        speed: 1000
                    });

                    mediaCarousels.push(mediaCarousel);
                });
            }

            if ($textCarousel) {
                const textCarousel = new Swiper($textCarousel, {
                    pagination: {
                        el: $pagination,
                        type: 'bullets',
                        clickable: true
                    },
                    controller: {
                        control: mediaCarousels
                    },
                    navigation: {
                        nextEl: $next,
                        prevEl: $prev
                    },
                    allowTouchMove: false,
                });

                textCarousel.on('slideChange', () => {
                    $accordions.forEach($accordion => {
                        $accordion.open = false;
                    });
                })
            }
        };

        const initParallax = () => {
            if (!$mediaCarousels) return;

            $mediaCarousels.forEach($mediaCarousel => {
                new Rellax($mediaCarousel, {
                    center: true,
                });
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousels();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousels();
            });
        } else {
            window.addEventListener('load', () => {
                const swiperScript = document.querySelector('#ofg-education-swiper-js');

                if (!swiperScript) return;

                initCarousels();
            });
        }

        if (typeof Rellax !== 'undefined') {
            initParallax();
        } else if (rellaxScript) {
            rellaxScript.addEventListener('load', () => {
                initParallax();
            });
        } else {
            window.addEventListener('load', () => {
                const rellaxScript = document.querySelector('#ofg-education-rellax-js');

                if (!rellaxScript) return;

                initParallax();
            });
        }
    });
})();
